<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="dedication">
<p class="dedicationText3"><span class="center">TO THE MOTHER OF MAJOR “MICK” MANNOCK, V.C.<br/>AND ALL WAR PILOTS WHO DID NOT FAIL IN THEIR DUTY</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KingofAirfighters_dedication.vue?979669a4